// Based on Amsterdam Styled Components
// See https://amsterdam.github.io/amsterdam-styled-components/?path=/docs/utils-breakpoint--min-with-laptop-m
// for more info

export const BREAKPOINTS = {
	mobileS: 320,
	mobileM: 375,
	mobileL: 414,
	tabletS: 540,
	tabletM: 768,
	laptop: 1024,
	laptopM: 1200,
	laptopL: 1430,
	desktop: 1920,
	desktopL: 2560,
};
